import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportCategory, ReportItemScopeKey, ReportItemTypeKey } from '../../../reporting.model';
import { ReportKey } from '../../../reports/report.registry';

interface ReportCategoryUpsertRequest {
    categoryName: string;
    reportItemTypeKey: ReportItemTypeKey;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class ReportingSavedItemCategoryService {
    private httpClient = inject(HttpClient);

    get(reportKey: ReportKey, subscriberKey: number | null): Observable<ReportCategory[]> {
        let params = new HttpParams();
        if (subscriberKey != null) {
            params = params.set('subscriberKey', subscriberKey);
        }

        return this.httpClient.get<ReportCategory[]>(`api/common/reports/${reportKey}/categories`, { params });
    }

    createUncategorizedCategory(reportKey: ReportKey, reportItemTypeKey: ReportItemTypeKey): ReportCategory {
        return {
            categoryKey: null,
            categoryName: 'Uncategorized',
            reportKey,
            reportItemTypeKey,
            reportItemScopeKey: ReportItemScopeKey.User,
            subscriberKey: null,
            userId: null,
            isUncategorized: true
        };
    }

    create(reportKey: ReportKey, reportItemTypeKey: ReportItemTypeKey, name: string, scopeKey: ReportItemScopeKey, subscriberKey: number | null, userId: string | null): Observable<number> {
        return this.httpClient.post<number>(`api/common/reports/${reportKey}/categories`, {
            categoryName: name,
            reportItemTypeKey,
            reportItemScopeKey: scopeKey,
            subscriberKey,
            userId
        } satisfies ReportCategoryUpsertRequest);
    }

    update(reportKey: ReportKey, category: ReportCategory): Observable<number> {
        if (category.categoryKey == null) {
            throw new Error('Cannot update the Uncategorized category.');
        }

        return this.httpClient.put<number>(`api/common/reports/${reportKey}/categories/${category.categoryKey}`, {
            categoryName: category.categoryName,
            reportItemTypeKey: category.reportItemTypeKey,
            reportItemScopeKey: category.reportItemScopeKey,
            subscriberKey: category.subscriberKey,
            userId: category.userId
        } satisfies ReportCategoryUpsertRequest);
    }

    delete(reportKey: ReportKey, categoryKey: number, subscriberKey: number | null): Observable<void> {
        let params = new HttpParams();
        if (subscriberKey != null) {
            params = params.set('subscriberKey', subscriberKey);
        }

        return this.httpClient.delete<void>(`api/common/reports/${reportKey}/categories/${categoryKey}`, { params });
    }

}
